export function useDevice() {
  const isIOS = ref(false)
  const isIPhone = ref(false)
  const isIPad = ref(false)
  const iosVersion = ref(null)

  const checkDevice = () => {
    const ua = navigator.userAgent.toLowerCase()

    // 检测设备类型
    isIPhone.value = /iphone/.test(ua)
    isIPad.value = /ipad/.test(ua) || (/macintosh/.test(ua) && 'ontouchend' in document)

    isIOS.value = isIPhone.value || isIPad.value || /ipod/.test(ua)

    // 获取iOS版本
    if (isIOS.value) {
      const match = ua.match(/os (\d+)[._](\d+)(?:[._](\d+))?/)
      if (match) {
        iosVersion.value = {
          major: parseInt(match[1], 10),
          minor: parseInt(match[2], 10),
          patch: match[3] ? parseInt(match[3], 10) : 0,
        }
      }
    }
  }

  onMounted(() => {
    checkDevice()
  })

  return {
    isIOS,
    isIPhone,
    isIPad,
    iosVersion,
  }
}
